import { ApiParams, BaseClient, IActionResponse, IActionResult, IPagedResult, } from "../../../assets/utils/lib";
import { SearchDto, SectionDto } from "../../dto";

export class SectionClient extends BaseClient {
    routes = ["questionnaire", "questionnaire"];

    async getSectionAsync(id: string | undefined): Promise<SectionDto> {
        const actions: string[] = ["GetSection"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];

        const result: SectionDto = await this.getAsync<SectionDto>(actions, params);
        return result;
    }

    async SearchSectionAsync(payload: SearchDto | undefined): Promise<IPagedResult<SectionDto>> {
        const actions: string[] = ["SearchSection"];
        const result: IPagedResult<SectionDto> = await this.postAsync<SearchDto, SectionDto, IPagedResult<SectionDto>>(actions, payload);
        return result;
    }

    async SaveSectionAsync(payload: SectionDto | undefined): Promise<IActionResult<SectionDto>> {
        const actions: string[] = ["SaveSection"];
        return await this.postAsync<SectionDto>(actions, payload);
    }

    async deleteSectionAsync(id?: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteSection"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];

        return await this.deleteAsync(actions, params);
    }
}
